(() => {
  'use strict';

  const dashboard =
    document.querySelector(
      '[data-pnadm-dashboard]'
    );


  const root =
    dashboard?.querySelector(
      '[data-pnops-root]'
    );


  if (
    !dashboard ||
    !root
  ) {
    return;
  }


  const LABELS = {

    users:
      'Users',

    colleges:
      'Colleges',

    bookings:
      'Bookings',

    payments:
      'Payments',

    events:
      'Events',

    communities:
      'Communities',

    reviews:
      'Reviews',

    analytics:
      'Analytics',

    logs:
      'Admin Logs'

  };


  const DESCRIPTIONS = {

    users:
      'Manage account access and platform roles.',

    colleges:
      'Manage college records and publishing.',

    bookings:
      'Mentor sessions and event registrations in one place.',

    payments:
      'Review PeerNest payment records.',

    events:
      'Review and manage event records.',

    communities:
      'Community inventory and moderation.',

    reviews:
      'Ratings and review records.',

    analytics:
      'Platform activity and usage signals.',

    logs:
      'Administrative activity trail.'

  };


  let currentTab =
    'users';


  let rows =
    [];


  let searchTerm =
    '';


  let bookingType =
    'all';


  let bookingStatus =
    'all';


  let ready =
    false;


  let currentProfile =
    null;


  function clean(
    value,
    fallback = '—'
  ) {

    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return fallback;
    }


    return String(
      value
    );

  }


  function escapeHTML(
    value
  ) {

    return clean(
      value,
      ''
    )
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );

  }


  function first(
    row,
    keys,
    fallback = '—'
  ) {

    for (
      const key
      of keys
    ) {

      if (
        row?.[key] !==
          undefined &&
        row?.[key] !==
          null &&
        row?.[key] !==
          ''
      ) {

        return row[key];

      }

    }


    return fallback;

  }


  function dateText(
    value
  ) {

    if (!value) {
      return '—';
    }


    const date =
      new Date(
        value
      );


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return clean(value);
    }


    return date.toLocaleString(
      'en-IN',
      {
        dateStyle:
          'medium',

        timeStyle:
          'short'
      }
    );

  }


  function money(
    value
  ) {

    const number =
      Number(
        value
      );


    if (
      !Number.isFinite(
        number
      )
    ) {
      return clean(value);
    }


    return new Intl
      .NumberFormat(
        'en-IN',
        {
          style:
            'currency',

          currency:
            'INR',

          maximumFractionDigits:
            0
        }
      )
      .format(
        number
      );

  }


  function pill(
    value
  ) {

    const state =
      clean(
        value,
        'unknown'
      )
        .toLowerCase();


    return `
      <span
        class="pnops__pill"
        data-state="${escapeHTML(state)}"
      >
        ${escapeHTML(
          state.replaceAll(
            '_',
            ' '
          )
        )}
      </span>
    `;

  }


  function mount() {

    root.innerHTML = `
      <div class="pnops">

        <div class="pnops__head">

          <div>

            <span data-pnops-eyebrow>
              ADMIN
            </span>

            <h2 data-pnops-title>
              Users
            </h2>

            <p data-pnops-description>
              Manage account access and platform roles.
            </p>

          </div>

        </div>


        <div class="pnops__toolbar">

          <div
            class="pnops__toolbar-left"
            data-pnops-filters
          ></div>


          <div class="pnops__toolbar-right">

            <input
              type="search"
              class="pnops__search"
              placeholder="Search this view…"
              data-pnops-search
            >


            <button
              type="button"
              class="pnops__refresh"
              data-pnops-refresh
            >
              Refresh
            </button>

          </div>

        </div>


        <div class="pnops__workspace">

          <div data-pnops-body></div>

          <div
            class="pnops__meta"
            data-pnops-meta
          ></div>

        </div>

      </div>
    `;


    root
      .querySelector(
        '[data-pnops-search]'
      )
      ?.addEventListener(
        'input',
        event => {

          searchTerm =
            String(
              event.target.value ||
              ''
            )
              .trim()
              .toLowerCase();


          render();

        }
      );


    root
      .querySelector(
        '[data-pnops-refresh]'
      )
      ?.addEventListener(
        'click',
        () =>
          load(
            currentTab
          )
      );

  }


  function table(
    headings,
    body
  ) {

    if (!body) {

      return `
        <div class="pnops__state">
          No matching records.
        </div>
      `;

    }


    return `
      <div class="pnops__table-wrap">

        <table class="pnops__table">

          <thead>
            <tr>
              ${headings
                .map(
                  item =>
                    `<th>${escapeHTML(item)}</th>`
                )
                .join('')}
            </tr>
          </thead>

          <tbody>
            ${body}
          </tbody>

        </table>

      </div>
    `;

  }


  function searchRows(
    source
  ) {

    if (
      !searchTerm
    ) {
      return source;
    }


    return source.filter(
      row => {

        try {

          return JSON
            .stringify(
              row
            )
            .toLowerCase()
            .includes(
              searchTerm
            );

        }
        catch (_) {
          return false;
        }

      }
    );

  }


  function filtersHTML() {

    const node =
      root.querySelector(
        '[data-pnops-filters]'
      );


    if (!node) {
      return;
    }


    if (
      currentTab !==
      'bookings'
    ) {

      node.innerHTML =
        '';

      return;

    }


    node.innerHTML = `
      <select
        class="pnops__select"
        data-pnops-booking-type
      >

        <option value="all">
          All bookings
        </option>

        <option value="mentor">
          Mentor sessions
        </option>

        <option value="event">
          Event registrations
        </option>

      </select>


      <select
        class="pnops__select"
        data-pnops-booking-status
      >

        <option value="all">
          All statuses
        </option>

        <option value="pending">
          Pending
        </option>

        <option value="reserved">
          Reserved
        </option>

        <option value="payment_pending">
          Payment pending
        </option>

        <option value="confirmed">
          Confirmed
        </option>

        <option value="completed">
          Completed
        </option>

        <option value="cancelled">
          Cancelled
        </option>

        <option value="rejected">
          Rejected
        </option>

        <option value="refunded">
          Refunded
        </option>

      </select>
    `;


    const type =
      node.querySelector(
        '[data-pnops-booking-type]'
      );


    const status =
      node.querySelector(
        '[data-pnops-booking-status]'
      );


    if (type) {

      type.value =
        bookingType;


      type.addEventListener(
        'change',
        () => {

          bookingType =
            type.value;

          render();

        }
      );

    }


    if (status) {

      status.value =
        bookingStatus;


      status.addEventListener(
        'change',
        () => {

          bookingStatus =
            status.value;

          render();

        }
      );

    }

  }


  async function fetchRows(
    tab
  ) {

    if (
      tab ===
      'users'
    ) {

      const result =
        await window.PeerNestDB
          .request(
            'rpc/admin_list_users',
            '',
            {
              method:
                'POST',

              body:{}
            }
          );


      return Array.isArray(
        result
      )
        ? result
        : [];

    }


    if (
      tab ===
      'bookings'
    ) {

      const result =
        await Promise.allSettled([

          window.PeerNestDB
            .request(
              'rpc/admin_list_bookings',
              '',
              {
                method:
                  'POST',

                body:{}
              }
            ),

          window.PeerNestDB
            .request(
              'event_registrations',
              'select=*&limit=200'
            )

        ]);


      const mentors =
        result[0].status ===
        'fulfilled'
          ? result[0].value
          : [];


      const events =
        result[1].status ===
        'fulfilled'
          ? result[1].value
          : [];


      if (
        result[0].status ===
          'rejected' &&
        result[1].status ===
          'rejected'
      ) {

        throw (
          result[0].reason ||
          result[1].reason
        );

      }


      return [

        ...(
          Array.isArray(
            mentors
          )
            ? mentors.map(
                row => ({
                  ...row,

                  _pn_type:
                    'mentor'
                })
              )
            : []
        ),

        ...(
          Array.isArray(
            events
          )
            ? events.map(
                row => ({
                  ...row,

                  _pn_type:
                    'event'
                })
              )
            : []
        )

      ];

    }




    // PN_COLLEGE_LIBRARY_PARITY_V1
    // Public Colleges uses is_published=true (no mentor filter).
    // Always include every public college, then enrich with records
    // referenced by approved requests or approved mentor profiles.
    // The large AISHE registry is browsed on demand via View All.
    if (tab === 'colleges') {
      const publicRows = await window.PeerNestDB.request(
        'colleges',
        'select=*&is_published=eq.true&order=name.asc'
      );
      if (!Array.isArray(publicRows)) {
        throw new Error('College Studio: public college query failed.');
      }

      const map = new Map();
      publicRows.forEach(item => {
        if (item?.id) map.set(item.id, item);
      });

      const optional = await Promise.allSettled([
        window.PeerNestDB.request(
          'college_requests',
          'select=resolved_college_id&status=in.(approved,merged)&' +
          'resolved_college_id=not.is.null&order=created_at.desc&limit=500'
        ),
        window.PeerNestDB.request('rpc/admin_list_mentors', '', {
          method: 'POST', body: {}
        })
      ]);

      const ids = new Set();
      const fallbackNames = new Set();
      const isUUID = /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;

      if (optional[0].status === 'fulfilled' && Array.isArray(optional[0].value)) {
        optional[0].value.forEach(item => {
          if (isUUID.test(String(item?.resolved_college_id || '')))
            ids.add(item.resolved_college_id);
        });
      } else {
        console.warn('[PeerNest] College Studio: approved-request enrichment unavailable.', optional[0].reason);
      }

      if (optional[1].status === 'fulfilled' && Array.isArray(optional[1].value)) {
        optional[1].value.forEach(mentor => {
          if (String(mentor.status || '').toLowerCase() !== 'approved') return;
          const id = String(mentor.college_id || '').trim();
          const name = String(mentor.college_name || '').trim();
          if (isUUID.test(id)) ids.add(id);
          else if (name && name.toLowerCase() !== 'n/a') fallbackNames.add(name);
        });
      } else {
        console.warn('[PeerNest] College Studio: mentor-linked draft enrichment unavailable.', optional[1].reason);
      }

      const pendingIds = [...ids].filter(id => !map.has(id));
      for (let index = 0; index < pendingIds.length; index += 40) {
        const batch = pendingIds.slice(index, index + 40);
        const found = await window.PeerNestDB.request(
          'colleges', 'select=*&id=in.(' + batch.join(',') + ')'
        );
        if (!Array.isArray(found)) throw new Error('College Studio: linked college lookup failed.');
        found.forEach(item => { if (item?.id) map.set(item.id, item); });
      }

      // Preserve support for older mentor RPCs without college_id.
      for (const name of fallbackNames) {
        const found = await window.PeerNestDB.request(
          'colleges', 'select=*&name=eq.' + encodeURIComponent(name) + '&limit=2'
        );
        if (Array.isArray(found) && found.length === 1 && found[0]?.id)
          map.set(found[0].id, found[0]);
      }

      return [...map.values()].sort((a, b) =>
        String(a.name || '').localeCompare(String(b.name || ''))
      );
    }

    const tables = {

      users:
        'profiles',

      colleges:
        'colleges',

      payments:
        'payments',

      events:
        'events',

      communities:
        'communities',

      reviews:
        'reviews',

      analytics:
        'analytics_events',

      logs:
        'admin_logs'

    };


    const tableName =
      tables[tab];


    if (!tableName) {
      return [];
    }


    const result =
      await window.PeerNestDB
        .request(
          tableName,
          'select=*&limit=200'
        );


    return Array.isArray(
      result
    )
      ? result
      : [];

  }


  function renderUsers(
    source
  ) {

    return table(
      [
        'User',
        'Role',
        'Status',
        'Created',
        'Access'
      ],

      source
        .map(
          row => {

            const name =
              first(
                row,
                [
                  'full_name',
                  'display_name',
                  'name'
                ],
                'Unnamed user'
              );


            const status =
              first(
                row,
                [
                  'account_status',
                  'status'
                ],
                'active'
              );


            const protectedRow =
              row.id ===
              currentProfile?.id;


            return `
              <tr>

                <td>

                  <span class="pnops__primary">
                    ${escapeHTML(name)}
                  </span>

                  <span class="pnops__secondary">
                    ${escapeHTML(
                      first(
                        row,
                        ['email'],
                        ''
                      )
                    )}
                  </span>

                </td>


                <td>
                  ${pill(
                    first(
                      row,
                      ['role'],
                      'student'
                    )
                  )}
                </td>


                <td>
                  ${pill(status)}
                </td>


                <td>
                  ${escapeHTML(
                    dateText(
                      row.created_at
                    )
                  )}
                </td>


                <td>

                  <select
                    class="pnops__status-select"
                    data-pnops-user-status="${escapeHTML(row.id)}"
                    ${protectedRow ? 'disabled' : ''}
                  >

                    <option
                      value="active"
                      ${status === 'active' ? 'selected' : ''}
                    >
                      Active
                    </option>

                    <option
                      value="suspended"
                      ${status === 'suspended' ? 'selected' : ''}
                    >
                      Suspended
                    </option>

                    <option
                      value="disabled"
                      ${status === 'disabled' ? 'selected' : ''}
                    >
                      Disabled
                    </option>

                  </select>

                </td>

              </tr>
            `;

          }
        )
        .join('')
    );

  }


  /* ========================================================
     PHASE 10 — COLLEGE CMS / COLLEGE STUDIO
     ======================================================== */

  let collegeCMSBound =
    false;

  let collegeCMSSelectedId =
    null;

  let collegeCMSFilter =
    'all';

  /* ========================================================
     COLLEGE REQUESTS — embedded in existing College Studio
     Uses the existing authenticated PeerNestDB transport.
     ======================================================== */

  let collegeRequests = [];
  let collegeRequestsLoading = false;
  let collegeRequestsError = '';
  let collegeRequestsView = 'pending';
  let collegeRequestSelected = null;
  let collegeRequestMode = '';
  let collegeRequestMatch = null;
  let collegeRequestsRevision = 0;
  let collegeRequestSearchRevision = 0;
  let collegeRequestSearchTimer = null;
  let collegeRequestBindingsReady = false;

  function collegeRequestPanelHTML() {
    const pending = collegeRequests.filter(row => row.status === 'pending');
    const history = collegeRequests.filter(row => row.status !== 'pending');
    const shown = collegeRequestsView === 'pending' ? pending : history;

    return `
      <section class="pncms-requests" aria-label="College requests">
        <div class="pncms-requests__heading">
          <div>
            <span class="pncms__eyebrow">College verification</span>
            <h3>College requests</h3>
            <p>Review missing colleges. Approving a request does not publish its profile.</p>
          </div>
          <button type="button" class="pncms-requests__refresh" data-pncms-requests-refresh>Refresh</button>
        </div>
        <div class="pncms-requests__tabs">
          <button type="button" data-pncms-requests-view="pending"
            class="${collegeRequestsView === 'pending' ? 'is-active' : ''}">
            Pending (${pending.length}${pending.length === 200 ? '+' : ''})
          </button>
          <button type="button" data-pncms-requests-view="history"
            class="${collegeRequestsView === 'history' ? 'is-active' : ''}">
            History (${history.length}${history.length === 100 ? '+' : ''})
          </button>
        </div>
        ${collegeRequestsLoading ? '<p class="pncms-requests__info">Loading requests…</p>' : ''}
        ${collegeRequestsError ? `<p class="pncms-requests__error" role="alert">${escapeHTML(collegeRequestsError)}</p>` : ''}
        ${!collegeRequestsLoading && !collegeRequestsError && !shown.length
          ? '<p class="pncms-requests__info">No requests in this view.</p>' : ''}
        <div class="pncms-requests__list">
          ${!collegeRequestsLoading ? shown.map(collegeRequestCardHTML).join('') : ''}
        </div>
      </section>
    `;
  }

  function collegeRequestCardHTML(row) {
    const editing = collegeRequestSelected === row.id && row.status === 'pending';
    const id = escapeHTML(row.id);
    const website = String(row.website_url || '');
    let hostname = '';
    try { hostname = new URL(website).hostname.toLowerCase(); } catch (_) { /* shown as text */ }
    const suspicious = hostname === 'peernest.in' || hostname.endsWith('.peernest.in');
    const validHref = /^https?:\/\//i.test(website) ? website : '';

    return `
      <article class="pncms-requests__card" data-pncms-request-card="${id}">
        <div class="pncms-requests__card-head">
          <div>
            <strong>${escapeHTML(row.requested_name)}</strong>
            <p>${escapeHTML([row.city, row.state, row.country].filter(Boolean).join(', '))}</p>
          </div>
          <span class="pncms-requests__status" data-status="${escapeHTML(row.status)}">${escapeHTML(row.status)}</span>
        </div>
        <div class="pncms-requests__details">
          <span>Requested ${escapeHTML(dateText(row.created_at))}</span>
          ${validHref ? `<a href="${escapeHTML(validHref)}" target="_blank" rel="noopener noreferrer">Submitted website ↗</a>` : `<span>${escapeHTML(website)}</span>`}
          ${suspicious ? '<span class="pncms-requests__warning">The submitted website points to PeerNest, not this college. Verify before approving.</span>' : ''}
          ${row.resolved_college_id ? `<span>Linked college: ${escapeHTML(row.resolved_college_id)}</span>` : ''}
          ${row.resolved_college_id && (row.status === 'approved' || row.status === 'merged') ? `
            <button type="button" class="pncms-requests__primary"
              data-pncms-request-open="${escapeHTML(row.resolved_college_id)}">Manage approved college ↗</button>
          ` : ''}
          ${row.admin_notes ? `<span>Review notes: ${escapeHTML(row.admin_notes)}</span>` : ''}
        </div>
        ${row.status === 'pending' ? `
          <div class="pncms-requests__actions">
            <button type="button" data-pncms-request-mode="approve" data-request-id="${id}">Approve new</button>
            <button type="button" data-pncms-request-mode="merge" data-request-id="${id}">Link existing</button>
            <button type="button" data-pncms-request-mode="reject" data-request-id="${id}">Reject</button>
          </div>
          ${editing ? `
            <div class="pncms-requests__form">
              ${collegeRequestMode === 'approve' ? `
                <label>Verified official website
                  <input type="url" data-pncms-request-website value="${escapeHTML(website)}" placeholder="https://college.edu" />
                </label>
                <label class="pncms-requests__check"><input type="checkbox" data-pncms-request-verified />
                  I verified the college and its official website. Create a draft, searchable registry record.
                </label>
              ` : ''}
              ${collegeRequestMode === 'merge' ? `
                <label>Find the existing college in the full AISHE registry
                  <input type="search" autocomplete="off" data-pncms-request-search placeholder="Search by name, AISHE code or short name" />
                </label>
                <div class="pncms-requests__matches" data-pncms-request-matches>Type at least 2 characters.</div>
                <div class="pncms-requests__selected" data-pncms-request-selected>No college selected.</div>
              ` : ''}
              <label>${collegeRequestMode === 'reject' ? 'Rejection reason (required)' : 'Admin notes (optional)'}
                <textarea rows="2" data-pncms-request-notes placeholder="Review details"></textarea>
              </label>
              <div class="pncms-requests__actions">
                <button type="button" class="pncms-requests__primary" data-pncms-request-submit>Confirm ${escapeHTML(collegeRequestMode)}</button>
                <button type="button" data-pncms-request-cancel>Cancel</button>
              </div>
            </div>
          ` : ''}
        ` : ''}
      </article>
    `;
  }

  function refreshCollegeRequestsPanel() {
    const slot = root.querySelector('[data-pncms-requests-root]');
    if (slot && currentTab === 'colleges') slot.innerHTML = collegeRequestPanelHTML();
  }

  async function refreshCollegeRequests() {
    if (currentTab !== 'colleges') return;
    const revision = ++collegeRequestsRevision;
    collegeRequestsLoading = true;
    collegeRequestsError = '';
    refreshCollegeRequestsPanel();
    const fields = 'id,submitted_by,requested_name,city,state,country,website_url,status,admin_notes,reviewed_by,reviewed_at,created_at,possible_college_id,resolved_college_id';
    try {
      const [pending, history] = await Promise.all([
        window.PeerNestDB.request('college_requests', `select=${fields}&status=eq.pending&order=created_at.desc&limit=200`),
        window.PeerNestDB.request('college_requests', `select=${fields}&status=in.(approved,merged,rejected)&order=created_at.desc&limit=100`)
      ]);
      if (revision !== collegeRequestsRevision || currentTab !== 'colleges') return;
      collegeRequests = [...(Array.isArray(pending) ? pending : []), ...(Array.isArray(history) ? history : [])];
    } catch (error) {
      if (revision !== collegeRequestsRevision || currentTab !== 'colleges') return;
      console.error('[PeerNest College Requests] load:', error);
      collegeRequestsError = error?.message || 'Could not load college requests.';
    } finally {
      if (revision === collegeRequestsRevision) {
        collegeRequestsLoading = false;
        refreshCollegeRequestsPanel();
      }
    }
  }

  function ensureCollegeRequestBindings() {
    if (collegeRequestBindingsReady) return;
    collegeRequestBindingsReady = true;

    document.addEventListener('click', async event => {
      if (currentTab !== 'colleges') return;
      const target = event.target;
      if (!(target instanceof Element) || !root.contains(target)) return;

      const refresh = target.closest('[data-pncms-requests-refresh]');
      if (refresh) { event.preventDefault(); await refreshCollegeRequests(); return; }

      const view = target.closest('[data-pncms-requests-view]');
      if (view) {
        event.preventDefault();
        collegeRequestsView = view.dataset.pncmsRequestsView;
        collegeRequestSelected = null;
        collegeRequestMode = '';
        collegeRequestMatch = null;
        refreshCollegeRequestsPanel();
        return;
      }

      const mode = target.closest('[data-pncms-request-mode]');
      if (mode) {
        event.preventDefault();
        collegeRequestSelected = mode.dataset.requestId;
        collegeRequestMode = mode.dataset.pncmsRequestMode;
        collegeRequestMatch = null;
        collegeRequestSearchRevision++;
        refreshCollegeRequestsPanel();
        return;
      }

      if (target.closest('[data-pncms-request-cancel]')) {
        event.preventDefault();
        collegeRequestSelected = null;
        collegeRequestMode = '';
        collegeRequestMatch = null;
        refreshCollegeRequestsPanel();
        return;
      }

      const choose = target.closest('[data-pncms-request-choose]');
      if (choose) {
        event.preventDefault();
        collegeRequestMatch = {
          id: choose.dataset.pncmsRequestChoose,
          label: choose.dataset.collegeLabel || 'Existing college'
        };
        const card = choose.closest('[data-pncms-request-card]');
        const selected = card?.querySelector('[data-pncms-request-selected]');
        if (selected) selected.textContent = `Selected: ${collegeRequestMatch.label}`;
        return;
      }

      const openApproved = target.closest('[data-pncms-request-open]');
      if (openApproved) {
        event.preventDefault();
        try { await openCollegeFromDirectory(openApproved.dataset.pncmsRequestOpen); }
        catch (error) { alert(error?.message || 'Could not open the approved college.'); }
        return;
      }

      const submit = target.closest('[data-pncms-request-submit]');
      if (!submit) return;
      event.preventDefault();
      const card = submit.closest('[data-pncms-request-card]');
      const requestId = card?.dataset.pncmsRequestCard;
      if (!requestId || requestId !== collegeRequestSelected) return;
      const action = collegeRequestMode;
      const notes = card.querySelector('[data-pncms-request-notes]')?.value.trim() || '';
      const website = card.querySelector('[data-pncms-request-website]')?.value.trim() || '';
      if (action === 'reject' && !notes) { alert('Enter a reason for rejecting this request.'); return; }
      if (action === 'merge' && !collegeRequestMatch?.id) { alert('Select the matching college from the search results.'); return; }
      if (action === 'approve') {
        if (!/^https?:\/\/[^\s]+$/i.test(website)) { alert('Enter the verified official college website.'); return; }
        let host = '';
        try { host = new URL(website).hostname.toLowerCase(); } catch (_) { /* invalid URL */ }
        if (host === 'peernest.in' || host.endsWith('.peernest.in')) {
          alert('Replace the PeerNest test URL with the actual official college website.'); return;
        }
        if (!card.querySelector('[data-pncms-request-verified]')?.checked) {
          alert('Confirm that you verified the college and website.'); return;
        }
      }
      if (!window.confirm(`Confirm ${action} for this college request?`)) return;
      const previousText = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Saving…';
      try {
        const result = await window.PeerNestDB.request('rpc/admin_review_college_request', '', {
          method: 'POST',
          body: {
            p_request_id: requestId,
            p_action: action,
            p_college_id: action === 'merge' ? collegeRequestMatch.id : null,
            p_admin_notes: notes || null,
            p_website_url: action === 'approve' ? website : null
          }
        });
        if (result?.id !== requestId || result?.status === 'pending') {
          throw new Error('The request was not confirmed as reviewed.');
        }
        collegeRequestSelected = null;
        collegeRequestMode = '';
        collegeRequestMatch = null;
        collegeCMSToast(action === 'approve'
          ? 'College added as a draft. Edit and publish it in the College Library.'
          : action === 'merge' ? 'Request linked to existing college.' : 'Request rejected.');
        // Immediately include approved/merged colleges in normal CMS management.
        await load('colleges');
      } catch (error) {
        console.error('[PeerNest College Requests] review:', error);
        alert(error?.message || 'Could not review this college request.');
        submit.disabled = false;
        submit.textContent = previousText;
      }
    });

    document.addEventListener('input', event => {
      if (currentTab !== 'colleges') return;
      const input = event.target;
      if (!(input instanceof Element) || !input.matches('[data-pncms-request-search]') || !root.contains(input)) return;
      const card = input.closest('[data-pncms-request-card]');
      const results = card?.querySelector('[data-pncms-request-matches]');
      if (!results) return;
      collegeRequestMatch = null;
      const selected = card.querySelector('[data-pncms-request-selected]');
      if (selected) selected.textContent = 'No college selected.';
      const query = input.value.trim();
      const requestId = card.dataset.pncmsRequestCard;
      const revision = ++collegeRequestSearchRevision;
      if (collegeRequestSearchTimer) clearTimeout(collegeRequestSearchTimer);
      if (query.length < 2) { results.textContent = 'Type at least 2 characters.'; return; }
      results.textContent = 'Searching the AISHE college registry…';
      collegeRequestSearchTimer = setTimeout(async () => {
        try {
          const matches = await window.PeerNestDB.request('rpc/search_college_registry', '', {
            method: 'POST', body: { p_query: query, p_limit: 10 }
          });
          if (revision !== collegeRequestSearchRevision || currentTab !== 'colleges'
              || collegeRequestSelected !== requestId || collegeRequestMode !== 'merge'
              || !results.isConnected) return;
          results.innerHTML = Array.isArray(matches) && matches.length
            ? matches.map(item => `
                <button type="button" data-pncms-request-choose="${escapeHTML(item.college_id)}"
                  data-college-label="${escapeHTML([item.name, item.city, item.state].filter(Boolean).join(' · '))}">
                  ${escapeHTML(item.name)} <small>${escapeHTML([item.city, item.state].filter(Boolean).join(', '))}</small>
                </button>
              `).join('')
            : 'No matching colleges found. Review the name or approve as a new college after verification.';
        } catch (error) {
          if (revision === collegeRequestSearchRevision && results.isConnected) {
            results.textContent = error?.message || 'Could not search colleges.';
          }
        }
      }, 250);
    });
  }



  function collegeCMSSlug(
    value
  ) {

    return String(
      value ||
      ''
    )
      .trim()
      .toLowerCase()
      .replace(
        /&/g,
        ' and '
      )
      .replace(
        /[^a-z0-9]+/g,
        '-'
      )
      .replace(
        /^-+|-+$/g,
        ''
      );

  }


  function collegeCMSInitials(
    value
  ) {

    const words =
      String(
        value ||
        ''
      )
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(
          0,
          2
        );

    return (
      words
        .map(
          word =>
            word.charAt(0)
        )
        .join('')
        .toUpperCase() ||
      'PN'
    );

  }


  function collegeCMSLocation(
    row
  ) {

    return [
      row?.city,
      row?.state
    ]
      .filter(Boolean)
      .join(', ') ||
      row?.country ||
      'Location not added';

  }


  function collegeCMSToast(
    message,
    type =
      'success'
  ) {

    document
      .querySelectorAll(
        '.pncms-toast'
      )
      .forEach(
        node =>
          node.remove()
      );


    const toast =
      document.createElement(
        'div'
      );

    toast.className =
      `pncms-toast ${
        type ===
        'error'
          ? 'pncms-toast--error'
          : ''
      }`;

    toast.textContent =
      message;

    document.body.appendChild(
      toast
    );


    window.setTimeout(
      () => {

        toast.remove();

      },
      3200
    );

  }


  function collegeCMSMedia(
    url,
    label,
    logo =
      false
  ) {

    const safeURL =
      escapeHTML(
        url ||
        ''
      );

    if (!safeURL) {

      return `
        <div class="pncms-media-card ${
          logo
            ? 'pncms-media-card--logo'
            : ''
        }">
          ${escapeHTML(label)}
        </div>
      `;

    }


    return `
      <div class="pncms-media-card ${
        logo
          ? 'pncms-media-card--logo'
          : ''
      }">
        <img
          src="${safeURL}"
          alt=""
        >
      </div>
    `;

  }


  function collegeCMSEmptyEditor() {

    return `
      <div class="pncms__editor-empty">
        <div class="pncms__editor-empty-inner">

          <div class="pncms__editor-visual">
            PN
          </div>

          <h3>
            Build a college profile
          </h3>

          <p>
            Select a college from the library or create a new one.
            Edit the information students see across PeerNest,
            then save it as a draft or publish it.
          </p>

        </div>
      </div>
    `;

  }


  function collegeCMSApplyFilter() {

    const root =
      document.querySelector(
        '.pncms'
      );

    if (!root) {
      return;
    }


    root
      .querySelectorAll(
        '[data-pncms-filter]'
      )
      .forEach(
        button => {

          button.classList.toggle(
            'is-active',
            button.dataset
              .pncmsFilter ===
            collegeCMSFilter
          );

        }
      );


    root
      .querySelectorAll(
        '[data-pncms-card]'
      )
      .forEach(
        card => {

          let visible =
            true;


          if (
            collegeCMSFilter ===
            'published'
          ) {

            visible =
              card.dataset
                .pncmsPublished ===
              'true';

          }


          if (
            collegeCMSFilter ===
            'draft'
          ) {

            visible =
              card.dataset
                .pncmsPublished !==
              'true';

          }


          if (
            collegeCMSFilter ===
            'featured'
          ) {

            visible =
              card.dataset
                .pncmsFeatured ===
              'true';

          }


          card.hidden =
            !visible;

        }
      );

  }


  function collegeCMSSwitchTab(
    tab
  ) {

    const editor =
      document.querySelector(
        '[data-pncms-editor]'
      );

    if (!editor) {
      return;
    }


    editor
      .querySelectorAll(
        '[data-pncms-tab]'
      )
      .forEach(
        button => {

          button.classList.toggle(
            'is-active',
            button.dataset
              .pncmsTab ===
            tab
          );

        }
      );


    editor
      .querySelectorAll(
        '[data-pncms-panel]'
      )
      .forEach(
        panel => {

          panel.classList.toggle(
            'is-active',
            panel.dataset
              .pncmsPanel ===
            tab
          );

        }
      );

  }


  function openCollegeEditor(
    row =
      null
  ) {

    const editor =
      document.querySelector(
        '[data-pncms-editor]'
      );

    if (!editor) {
      return;
    }


    const isNew =
      !row;

    const college =
      row ||
      {};


    collegeCMSSelectedId =
      college.id ||
      null;


    const name =
      college.name ||
      '';

    const published =
      Boolean(
        college.is_published
      );

    const featured =
      Boolean(
        college.is_featured
      );

    const location =
      collegeCMSLocation(
        college
      );

    const imageURL =
      college.image_url ||
      '';

    const logoURL =
      college.logo_url ||
      '';


    editor.innerHTML =
      `
        <form
          data-pncms-form
          data-pncms-id="${escapeHTML(
            college.id ||
            ''
          )}"
          data-pncms-published="${
            published
              ? 'true'
              : 'false'
          }"
        >

          <div class="pncms-editor__cover">

            ${
              imageURL
                ? `
                    <img
                      class="pncms-editor__cover-image"
                      src="${escapeHTML(imageURL)}"
                      alt=""
                    >
                  `
                : ''
            }

            <div class="pncms-editor__shade"></div>

            <div class="pncms-editor__top">

              <span class="pncms-editor__mode">
                ${
                  isNew
                    ? 'New college'
                    : published
                      ? 'Published'
                      : 'Draft'
                }
              </span>

              <button
                type="button"
                class="pncms-editor__close"
                data-pncms-close
                aria-label="Close editor"
              >
                ×
              </button>

            </div>


            <div class="pncms-editor__identity">

              <div class="pncms-editor__logo">

                ${
                  logoURL
                    ? `
                        <img
                          src="${escapeHTML(logoURL)}"
                          alt=""
                        >
                      `
                    : escapeHTML(
                        collegeCMSInitials(
                          name
                        )
                      )
                }

              </div>

              <div>

                <h3 data-pncms-preview-name>
                  ${escapeHTML(
                    name ||
                    'New college'
                  )}
                </h3>

                <p data-pncms-preview-location>
                  ${escapeHTML(
                    isNew
                      ? 'Create a new PeerNest college profile'
                      : location
                  )}
                </p>

              </div>

            </div>

          </div>


          <div class="pncms-editor__tabs">

            <button
              type="button"
              class="pncms-editor__tab is-active"
              data-pncms-tab="overview"
            >
              Overview
            </button>

            <button
              type="button"
              class="pncms-editor__tab"
              data-pncms-tab="media"
            >
              Media
            </button>

            <button
              type="button"
              class="pncms-editor__tab"
              data-pncms-tab="publishing"
            >
              Publishing
            </button>

          </div>


          <div class="pncms-editor__body">

            <div
              class="pncms-editor__panel is-active"
              data-pncms-panel="overview"
            >

              <div class="pncms-editor__section">

                <div class="pncms-editor__heading">
                  <strong>College identity</strong>
                  <span>
                    The primary information shown across PeerNest.
                  </span>
                </div>

                <div class="pncms-editor__grid">

                  <label class="pncms-field pncms-field--wide">
                    <span>College name *</span>
                    <input
                      type="text"
                      name="name"
                      value="${escapeHTML(name)}"
                      placeholder="PES University"
                      required
                      data-pncms-name
                    >
                  </label>


                  <label class="pncms-field">
                    <span>Short name</span>
                    <input
                      type="text"
                      name="short_name"
                      value="${escapeHTML(
                        college.short_name ||
                        ''
                      )}"
                      placeholder="PESU"
                    >
                  </label>


                  <label class="pncms-field">
                    <span>Slug *</span>

                    <div class="pncms-slug">

                      <input
                        type="text"
                        name="slug"
                        value="${escapeHTML(
                          college.slug ||
                          ''
                        )}"
                        placeholder="pes-university"
                        required
                        data-pncms-slug
                      >

                      <button
                        type="button"
                        data-pncms-generate-slug
                      >
                        Auto
                      </button>

                    </div>
                  </label>

                </div>

              </div>


              <div class="pncms-editor__section">

                <div class="pncms-editor__heading">
                  <strong>Location</strong>
                  <span>
                    Used across discovery, filtering and college profiles.
                  </span>
                </div>

                <div class="pncms-editor__grid pncms-editor__grid--3">

                  <label class="pncms-field">
                    <span>City</span>
                    <input
                      type="text"
                      name="city"
                      value="${escapeHTML(
                        college.city ||
                        ''
                      )}"
                      placeholder="Bengaluru"
                      data-pncms-city
                    >
                  </label>


                  <label class="pncms-field">
                    <span>State</span>
                    <input
                      type="text"
                      name="state"
                      value="${escapeHTML(
                        college.state ||
                        ''
                      )}"
                      placeholder="Karnataka"
                      data-pncms-state
                    >
                  </label>


                  <label class="pncms-field">
                    <span>Country</span>
                    <input
                      type="text"
                      name="country"
                      value="${escapeHTML(
                        college.country ||
                        'India'
                      )}"
                      placeholder="India"
                    >
                  </label>

                </div>

              </div>


              <div class="pncms-editor__section">

                <div class="pncms-editor__heading">
                  <strong>Profile details</strong>
                  <span>
                    Classification and the story students see first.
                  </span>
                </div>

                <div class="pncms-editor__grid">

                  <label class="pncms-field">
                    <span>College type</span>
                    <input
                      type="text"
                      name="college_type"
                      value="${escapeHTML(
                        college.college_type ||
                        ''
                      )}"
                      placeholder="University / Engineering / Junior College"
                    >
                  </label>


                  <label class="pncms-field">
                    <span>Ownership</span>
                    <input
                      type="text"
                      name="ownership_type"
                      value="${escapeHTML(
                        college.ownership_type ||
                        ''
                      )}"
                      placeholder="Private / Government"
                    >
                  </label>


                  <label class="pncms-field">
                    <span>Established year</span>
                    <input
                      type="number"
                      name="established_year"
                      min="1500"
                      max="2100"
                      value="${escapeHTML(
                        college.established_year ||
                        ''
                      )}"
                      placeholder="1988"
                    >
                  </label>


                  <label class="pncms-field pncms-field--wide">
                    <span>Description</span>
                    <textarea
                      name="description"
                      placeholder="Write a concise, student-friendly overview of this college..."
                    >${escapeHTML(
                      college.description ||
                      ''
                    )}</textarea>
                  </label>

                </div>

              </div>

            </div>


            <div
              class="pncms-editor__panel"
              data-pncms-panel="media"
            >

              <div class="pncms-editor__section">

                <div class="pncms-editor__heading">
                  <strong>College imagery</strong>
                  <span>
                    These URLs power college cards, detail pages and Compare.
                  </span>
                </div>

                <div class="pncms-upload-grid">

                  <!-- CAMPUS / COVER -->

                  <div class="pncms-upload-card">

                    <div class="pncms-upload-card__head">

                      <div>
                        <strong>
                          Campus / Cover Image
                        </strong>

                        <span>
                          Landscape image used on college cards,
                          detail pages and Compare.
                        </span>
                      </div>

                      <span class="pncms-upload-card__type">
                        COVER
                      </span>

                    </div>


                    <input
                      type="hidden"
                      name="image_url"
                      value="${escapeHTML(imageURL)}"
                      data-pncms-image-url
                    >


                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      data-pncms-media-file="cover"
                      id="pncms-cover-file"
                      hidden
                    >


                    <label
                      for="pncms-cover-file"
                      class="pncms-upload-drop ${
                        imageURL
                          ? 'has-image'
                          : ''
                      }"
                      data-pncms-cover-preview
                    >

                      ${
                        imageURL
                          ? `
                              <img
                                src="${escapeHTML(imageURL)}"
                                alt=""
                              >

                              <div class="pncms-upload-drop__overlay">

                                <span class="pncms-upload-drop__icon">
                                  ↥
                                </span>

                                <strong>
                                  Replace cover
                                </strong>

                                <small>
                                  JPG, PNG or WebP · max 5 MB
                                </small>

                              </div>
                            `
                          : `
                              <span class="pncms-upload-drop__icon">
                                +
                              </span>

                              <strong>
                                Upload campus image
                              </strong>

                              <small>
                                Click to choose from your computer
                              </small>

                              <em>
                                JPG · PNG · WEBP · MAX 5 MB
                              </em>
                            `
                      }

                    </label>


                    <div class="pncms-upload-actions">

                      <label
                        for="pncms-cover-file"
                        class="pncms-upload-action"
                      >
                        ${
                          imageURL
                            ? 'Replace image'
                            : 'Choose image'
                        }
                      </label>

                      ${
                        imageURL
                          ? `
                              <button
                                type="button"
                                class="pncms-upload-action pncms-upload-action--remove"
                                data-pncms-remove-media="cover"
                              >
                                Remove
                              </button>
                            `
                          : ''
                      }

                    </div>

                  </div>


                  <!-- LOGO -->

                  <div class="pncms-upload-card">

                    <div class="pncms-upload-card__head">

                      <div>
                        <strong>
                          College Logo
                        </strong>

                        <span>
                          Square logo used across listings
                          and the college identity.
                        </span>
                      </div>

                      <span class="pncms-upload-card__type">
                        LOGO
                      </span>

                    </div>


                    <input
                      type="hidden"
                      name="logo_url"
                      value="${escapeHTML(logoURL)}"
                      data-pncms-logo-url
                    >


                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      data-pncms-media-file="logo"
                      id="pncms-logo-file"
                      hidden
                    >


                    <label
                      for="pncms-logo-file"
                      class="pncms-upload-drop pncms-upload-drop--logo ${
                        logoURL
                          ? 'has-image'
                          : ''
                      }"
                      data-pncms-logo-preview
                    >

                      ${
                        logoURL
                          ? `
                              <img
                                src="${escapeHTML(logoURL)}"
                                alt=""
                              >

                              <div class="pncms-upload-drop__overlay">

                                <span class="pncms-upload-drop__icon">
                                  ↥
                                </span>

                                <strong>
                                  Replace logo
                                </strong>

                              </div>
                            `
                          : `
                              <span class="pncms-upload-drop__icon">
                                +
                              </span>

                              <strong>
                                Upload college logo
                              </strong>

                              <small>
                                Click to choose from your computer
                              </small>

                              <em>
                                JPG · PNG · WEBP
                              </em>
                            `
                      }

                    </label>


                    <div class="pncms-upload-actions">

                      <label
                        for="pncms-logo-file"
                        class="pncms-upload-action"
                      >
                        ${
                          logoURL
                            ? 'Replace logo'
                            : 'Choose logo'
                        }
                      </label>

                      ${
                        logoURL
                          ? `
                              <button
                                type="button"
                                class="pncms-upload-action pncms-upload-action--remove"
                                data-pncms-remove-media="logo"
                              >
                                Remove
                              </button>
                            `
                          : ''
                      }

                    </div>

                  </div>

                </div>


                <div
                  class="pncms-upload-status"
                  data-pncms-upload-status
                  hidden
                ></div>
                </div>

              </div>

            </div>


            <div
              class="pncms-editor__panel"
              data-pncms-panel="publishing"
            >

              <div class="pncms-editor__section">

                <div class="pncms-editor__heading">
                  <strong>Visibility</strong>
                  <span>
                    Control where this college appears across PeerNest.
                  </span>
                </div>


                <label class="pncms-toggle">

                  <div>
                    <strong>Featured college</strong>
                    <small>
                      Give this college additional prominence where
                      featured records are supported.
                    </small>
                  </div>

                  <input
                    type="checkbox"
                    name="is_featured"
                    ${
                      featured
                        ? 'checked'
                        : ''
                    }
                  >

                </label>


                <div class="pncms-toggle">

                  <div>
                    <strong>Current publishing state</strong>
                    <small>
                      ${
                        published
                          ? 'This college is visible to students.'
                          : 'This college is currently a draft.'
                      }
                    </small>
                  </div>

                  <span class="pncms__status ${
                    published
                      ? 'pncms__status--published'
                      : 'pncms__status--draft'
                  }">
                    ${
                      published
                        ? 'Published'
                        : 'Draft'
                    }
                  </span>

                </div>

              </div>

            </div>

          </div>


          <div class="pncms-editor__actions">

            <div class="pncms-editor__actions-left">

              <button
                type="button"
                class="pncms-btn"
                data-pncms-close
              >
                Cancel
              </button>

              <button
                type="button"
                class="pncms-btn pncms-btn--soft"
                data-pncms-save="draft"
              >
                Save Draft
              </button>

            </div>


            <div class="pncms-editor__actions-right">

              ${
                isNew
                  ? ''
                  : `
                      <button
                        type="button"
                        class="pncms-btn"
                        data-pncms-save="save"
                      >
                        Save Changes
                      </button>
                    `
              }

              <button
                type="button"
                class="pncms-btn pncms-btn--primary"
                data-pncms-save="publish"
              >
                ${
                  published
                    ? 'Save & Keep Published'
                    : 'Publish College'
                }
              </button>

            </div>

          </div>

        </form>
      `;


    collegeCMSSwitchTab(
      'overview'
    );

  }


  async function submitCollegeEditor(
    mode
  ) {

    const form =
      document.querySelector(
        '[data-pncms-form]'
      );

    if (!form) {
      return;
    }


    const data =
      new FormData(
        form
      );

    const name =
      String(
        data.get(
          'name'
        ) ||
        ''
      ).trim();

    let slug =
      String(
        data.get(
          'slug'
        ) ||
        ''
      ).trim();


    if (!name) {

      collegeCMSToast(
        'College name is required.',
        'error'
      );

      return;

    }


    if (!slug) {

      slug =
        collegeCMSSlug(
          name
        );

    }


    if (!slug) {

      collegeCMSToast(
        'A valid college slug is required.',
        'error'
      );

      return;

    }


    const yearValue =
      String(
        data.get(
          'established_year'
        ) ||
        ''
      ).trim();


    const currentPublished =
      form.dataset
        .pncmsPublished ===
      'true';


    let nextPublished =
      currentPublished;


    if (
      mode ===
      'draft'
    ) {

      nextPublished =
        false;

    }


    if (
      mode ===
      'publish'
    ) {

      nextPublished =
        true;

    }


    const nullable =
      value => {

        const clean =
          String(
            value ||
            ''
          ).trim();

        return clean ||
          null;

      };


    const payload = {

      name,

      short_name:
        nullable(
          data.get(
            'short_name'
          )
        ),

      slug,

      city:
        nullable(
          data.get(
            'city'
          )
        ),

      state:
        nullable(
          data.get(
            'state'
          )
        ),

      country:
        nullable(
          data.get(
            'country'
          )
        ),

      college_type:
        nullable(
          data.get(
            'college_type'
          )
        ),

      ownership_type:
        nullable(
          data.get(
            'ownership_type'
          )
        ),

      established_year:
        yearValue
          ? Number(
              yearValue
            )
          : null,
      description:
        nullable(
          data.get(
            'description'
          )
        ),

      accreditation:
        nullable(
          data.get(
            'accreditation'
          )
        ),

      website_url:
        nullable(
          data.get(
            'website_url'
          )
        ),

      search_keywords:
        String(
          data.get(
            'search_keywords'
          ) ||
          ''
        )
          .split(',')
          .map(
            item =>
              item.trim()
          )
          .filter(Boolean),

      image_url:
        nullable(
          data.get(
            'image_url'
          )
        ),

      logo_url:
        nullable(
          data.get(
            'logo_url'
          )
        ),

      is_featured:
        data.get(
          'is_featured'
        ) ===
        'on',

      is_published:
        nextPublished

    };


    const id =
      form.dataset
        .pncmsId ||
      '';


    const buttons =
      form.querySelectorAll(
        '[data-pncms-save]'
      );


    buttons.forEach(
      button => {

        button.disabled =
          true;

      }
    );


    try {

      const result =
        await window.PeerNestDB
          .request(
            'colleges',

            id
              ? `id=eq.${encodeURIComponent(
                  id
                )}`
              : '',

            {
              method:
                id
                  ? 'PATCH'
                  : 'POST',

              headers:{
                Prefer:
                  'return=representation'
              },

              body:
                payload
            }
          );


      const returnedRow =
        Array.isArray(
          result
        )
          ? result[0]
          : result;


      collegeCMSSelectedId =
        returnedRow?.id ||
        id ||
        null;


      await load(
        'colleges'
      );


      if (
        collegeCMSSelectedId
      ) {

        const refreshed =
          rows.find(
            item =>
              String(
                item.id
              ) ===
              String(
                collegeCMSSelectedId
              )
          );

        if (refreshed) {

          window.setTimeout(
            () =>
              openCollegeEditor(
                refreshed
              ),
            0
          );

        }

      }


      collegeCMSToast(
        mode ===
        'publish'
          ? 'College published successfully.'
          : mode ===
            'draft'
              ? 'College saved as draft.'
              : 'College changes saved.'
      );

    }


    catch (error) {

      console.error(
        '[PeerNest Admin] college CMS:',
        error
      );


      collegeCMSToast(
        error?.message ||
        'Could not save this college.',
        'error'
      );


      alert(
        error?.message ||
        'Could not save this college. If this is a new college, the current admin INSERT policy may be blocking creation.'
      );


      buttons.forEach(
        button => {

          button.disabled =
            false;

        }
      );

    }

  }


  async function deleteCollegeFromCMS(
    button
  ) {

    const collegeId =
      button?.dataset?.pncmsDelete;


    if (!collegeId) {
      return;
    }


    const row =
      rows.find(
        item =>
          String(
            item.id
          ) ===
          String(
            collegeId
          )
      );


    if (!row) {

      alert(
        'College could not be found.'
      );

      return;

    }


    const collegeName =
      row.name ||
      'this college';


    const confirmed =
      window.confirm(
        `Delete "${collegeName}" permanently?\n\n` +
        `This removes the college and its unused CMS data. ` +
        `PeerNest will block deletion if this college is already linked ` +
        `to mentors, students, bookings, saved data or Compare sessions.`
      );


    if (!confirmed) {
      return;
    }


    const previousText =
      button.textContent;


    button.disabled =
      true;


    button.textContent =
      'Deleting…';


    try {

      if (
        !window.PeerNestDB ||
        typeof window.PeerNestDB.request !==
          'function'
      ) {

        throw new Error(
          'PeerNest database is not ready.'
        );

      }


      await window.PeerNestDB.request(
        'rpc/admin_delete_college',
        '',
        {
          method:'POST',

          body:{
            p_college_id:
              collegeId
          }
        }
      );


      const index =
        rows.findIndex(
          item =>
            String(
              item.id
            ) ===
            String(
              collegeId
            )
        );


      if (index >= 0) {

        rows.splice(
          index,
          1
        );

      }


      collegeCMSSelectedId =
        null;


      /*
       * Re-render through the EXISTING College CMS renderer.
       * No extra event listener or override is introduced.
       */
      if (body) {

        body.innerHTML =
          renderColleges(
            searchRows(
              rows
            )
          );

      }

    }
    catch (error) {

      console.error(
        '[PeerNest College CMS] college delete:',
        error
      );


      alert(
        error?.message ||
        'Could not delete this college.'
      );


      button.disabled =
        false;


      button.textContent =
        previousText;

    }

  }


  // PN_COLLEGE_FULL_MANAGER_V1: paginated, on-demand directory.
  // No registry-wide unbounded fetch and no second editor/save backend.
  let allCollegeDialog = null;
  let allCollegePreviousFocus = null;
  let allCollegeEscapeHandler = null;
  let allCollegeScrollBefore = '';
  const allCollegePageSize = 30;
  const allCollegeState = {
    page: 0, filter: 'published', search: '', results: [],
    hasNext: false, revision: 0
  };

  function closeCollegeDirectory() {
    if (!allCollegeDialog) return;
    allCollegeState.revision += 1;
    allCollegeDialog.remove();
    allCollegeDialog = null;
    if (allCollegeEscapeHandler) {
      document.removeEventListener('keydown', allCollegeEscapeHandler);
      allCollegeEscapeHandler = null;
    }
    document.body.style.overflow = allCollegeScrollBefore;
    if (allCollegePreviousFocus?.isConnected) allCollegePreviousFocus.focus();
  }

  function renderCollegeDirectory(message = '') {
    const dialog = allCollegeDialog;
    if (!dialog) return;
    const start = allCollegeState.page * allCollegePageSize + 1;
    const end = start + allCollegeState.results.length - 1;
    const items = allCollegeState.results.map(row => `
      <article class="pncms-all__item">
        <div class="pncms-all__identity">
          <strong>${escapeHTML(row.name || 'Unnamed college')}</strong>
          <span>${escapeHTML([row.city, row.state].filter(Boolean).join(', ') || 'Location not set')}</span>
          <small>${row.is_published ? 'Published · Visible on Colleges' : 'Unpublished'}${row.is_featured ? ' · Featured' : ''}</small>
        </div>
        <div class="pncms-all__actions">
          <button type="button" data-pncms-all-edit="${escapeHTML(row.id)}">Edit</button>
          <button type="button" data-pncms-all-publish="${escapeHTML(row.id)}"
            data-pncms-all-next="${row.is_published ? 'false' : 'true'}">
            ${row.is_published ? 'Unpublish' : 'Publish'}
          </button>
          <button type="button" class="pncms-all__delete" data-pncms-all-delete="${escapeHTML(row.id)}">Delete</button>
        </div>
      </article>
    `).join('');

    dialog.innerHTML = `
      <div class="pncms-all__panel" role="dialog" aria-modal="true" aria-label="Full college manager">
        <header class="pncms-all__head">
          <div><span>PEERNEST COLLEGE STUDIO</span><h2>All colleges</h2>
            <p>Manage published colleges and browse the full registry. Only published records appear on the public Colleges page.</p></div>
          <button type="button" class="pncms-all__close" data-pncms-all-close aria-label="Close">×</button>
        </header>
        <div class="pncms-all__toolbar">
          <label class="pncms-all__search-label">
            <span>Find a college by name</span>
            <input type="search" data-pncms-all-search maxlength="80"
              value="${escapeHTML(allCollegeState.search)}" placeholder="Search the college registry">
          </label>
          <button type="button" class="pncms-all__search-button" data-pncms-all-run>Search</button>
          <label class="pncms-all__filter-label"><span>View</span>
            <select data-pncms-all-filter>
              <option value="published" ${allCollegeState.filter === 'published' ? 'selected' : ''}>Published — public Colleges page</option>
              <option value="unpublished" ${allCollegeState.filter === 'unpublished' ? 'selected' : ''}>Unpublished / drafts</option>
              <option value="featured" ${allCollegeState.filter === 'featured' ? 'selected' : ''}>Featured</option>
              <option value="all" ${allCollegeState.filter === 'all' ? 'selected' : ''}>Entire registry</option>
            </select>
          </label>
        </div>
        <main class="pncms-all__results" data-pncms-all-results>
          ${message ? `<p class="pncms-all__info">${escapeHTML(message)}</p>` : (items || '<p class="pncms-all__info">No colleges match this view.</p>')}
        </main>
        <footer class="pncms-all__footer">
          <span>${allCollegeState.results.length ? `Showing ${start}–${end} on page ${allCollegeState.page + 1}` : `Page ${allCollegeState.page + 1}`}</span>
          <div>
            <button type="button" data-pncms-all-prev ${allCollegeState.page ? '' : 'disabled'}>← Previous</button>
            <button type="button" data-pncms-all-next ${allCollegeState.hasNext ? '' : 'disabled'}>Next →</button>
          </div>
        </footer>
      </div>
    `;
  }

  async function loadCollegeDirectory() {
    if (!allCollegeDialog) return;
    const revision = ++allCollegeState.revision;
    renderCollegeDirectory('Loading colleges…');
    try {
      const parts = [
        'select=id,name,slug,city,state,is_published,is_featured',
        'order=name.asc',
        `limit=${allCollegePageSize + 1}`,
        `offset=${allCollegeState.page * allCollegePageSize}`
      ];
      if (allCollegeState.filter === 'published') parts.push('is_published=eq.true');
      if (allCollegeState.filter === 'unpublished') parts.push('is_published=eq.false');
      if (allCollegeState.filter === 'featured') parts.push('is_featured=eq.true');
      const safeSearch = allCollegeState.search
        .replace(/[^\p{L}\p{N} -]/gu, '').trim().slice(0, 80);
      if (safeSearch) parts.push('name=ilike.' + encodeURIComponent('*' + safeSearch + '*'));
      const data = await window.PeerNestDB.request('colleges', parts.join('&'));
      if (revision !== allCollegeState.revision || !allCollegeDialog) return;
      if (!Array.isArray(data)) throw new Error('The college directory returned an invalid response.');
      allCollegeState.hasNext = data.length > allCollegePageSize;
      allCollegeState.results = data.slice(0, allCollegePageSize);
      renderCollegeDirectory();
    } catch (error) {
      if (revision !== allCollegeState.revision || !allCollegeDialog) return;
      allCollegeState.results = [];
      allCollegeState.hasNext = false;
      renderCollegeDirectory('Could not load colleges: ' + (error?.message || 'Unknown error'));
    }
  }

  async function openCollegeFromDirectory(id) {
    const value = String(id || '');
    if (!/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(value))
      throw new Error('Invalid college ID.');
    const found = await window.PeerNestDB.request(
      'colleges', 'select=*&id=eq.' + encodeURIComponent(value) + '&limit=1'
    );
    if (!Array.isArray(found) || !found[0]) throw new Error('College could not be loaded.');
    const row = found[0];
    const position = rows.findIndex(item => item.id === row.id);
    if (position >= 0) rows[position] = row;
    else rows.push(row);
    collegeCMSSelectedId = row.id;
    closeCollegeDirectory();
    if (currentTab !== 'colleges') await load('colleges');
    render();
    openCollegeEditor(row);
    root.querySelector('[data-pncms-editor]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function openCollegeDirectory() {
    if (allCollegeDialog) { allCollegeDialog.querySelector('[data-pncms-all-search]')?.focus(); return; }
    allCollegePreviousFocus = document.activeElement;
    allCollegeScrollBefore = document.body.style.overflow;
    allCollegeState.page = 0;
    allCollegeState.filter = 'published';
    allCollegeState.search = '';
    allCollegeState.results = [];
    allCollegeState.hasNext = false;
    allCollegeDialog = document.createElement('div');
    allCollegeDialog.className = 'pncms-all';
    document.body.append(allCollegeDialog);
    document.body.style.overflow = 'hidden';
    allCollegeDialog.addEventListener('click', async event => {
      if (event.target === allCollegeDialog || event.target.closest('[data-pncms-all-close]')) {
        closeCollegeDirectory(); return;
      }
      const filter = event.target.closest('[data-pncms-all-filter]');
      if (filter) return;
      if (event.target.closest('[data-pncms-all-run]')) {
        allCollegeState.search = allCollegeDialog.querySelector('[data-pncms-all-search]')?.value.trim() || '';
        allCollegeState.page = 0; await loadCollegeDirectory(); return;
      }
      if (event.target.closest('[data-pncms-all-prev]')) {
        if (!allCollegeState.page) return;
        allCollegeState.page--; await loadCollegeDirectory(); return;
      }
      if (event.target.closest('[data-pncms-all-next]')) {
        if (!allCollegeState.hasNext) return;
        allCollegeState.page++; await loadCollegeDirectory(); return;
      }
      const edit = event.target.closest('[data-pncms-all-edit]');
      const pub = event.target.closest('[data-pncms-all-publish]');
      const del = event.target.closest('[data-pncms-all-delete]');
      if (!edit && !pub && !del) return;
      const button = edit || pub || del;
      button.disabled = true;
      try {
        if (edit) { await openCollegeFromDirectory(edit.dataset.pncmsAllEdit); return; }
        if (pub) {
          const response = await window.PeerNestDB.request('colleges',
            'id=eq.' + encodeURIComponent(pub.dataset.pncmsAllPublish), {
              method: 'PATCH', headers: { Prefer: 'return=representation' },
              body: { is_published: pub.dataset.pncmsAllNext === 'true' }
            });
          if (!Array.isArray(response) || response.length !== 1)
            throw new Error('Publish change was not confirmed.');
          await load('colleges');
          await loadCollegeDirectory();
          return;
        }
        if (del) {
          const id = del.dataset.pncmsAllDelete;
          // Reuse existing RPC, warnings and dependency protections.
          const found = await window.PeerNestDB.request('colleges',
            'select=*&id=eq.' + encodeURIComponent(id) + '&limit=1');
          if (!Array.isArray(found) || !found[0]) throw new Error('College could not be loaded.');
          const position = rows.findIndex(item => item.id === id);
          if (position >= 0) rows[position] = found[0];
          else rows.push(found[0]);
          await deleteCollegeFromCMS({ dataset: { pncmsDelete: id }, disabled: false,
            textContent: 'Delete' });
          await load('colleges');
          await loadCollegeDirectory();
        }
      } catch (error) {
        alert(error?.message || 'Could not update this college.');
      } finally { if (button.isConnected) button.disabled = false; }
    });
    allCollegeDialog.addEventListener('change', async event => {
      if (!event.target.matches('[data-pncms-all-filter]')) return;
      allCollegeState.filter = event.target.value;
      allCollegeState.page = 0;
      await loadCollegeDirectory();
    });
    allCollegeDialog.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('[data-pncms-all-search]')) {
        event.preventDefault();
        allCollegeState.search = event.target.value.trim();
        allCollegeState.page = 0;
        void loadCollegeDirectory();
      }
    });
    allCollegeEscapeHandler = event => {
      if (event.key !== 'Escape' || !allCollegeDialog) return;
      event.preventDefault();
      closeCollegeDirectory();
    };
    document.addEventListener('keydown', allCollegeEscapeHandler);
    renderCollegeDirectory('Loading colleges…');
    void loadCollegeDirectory();
    allCollegeDialog.querySelector('[data-pncms-all-search]')?.focus();
  }

  function ensureCollegeCMSBindings() {

    if (
      collegeCMSBound
    ) {

      return;

    }


    collegeCMSBound =
      true;


    document.addEventListener(
      'click',
      event => {

        const viewAll = event.target.closest('[data-pncms-view-all]');
        if (viewAll) {
          event.preventDefault();
          openCollegeDirectory();
          return;
        }

        const add =
          event.target.closest(
            '[data-pncms-add]'
          );

        if (add) {

          event.preventDefault();

          openCollegeEditor();

          return;

        }


        const edit =
          event.target.closest(
            '[data-pncms-edit]'
          );

        if (edit) {

          event.preventDefault();


          const row =
            rows.find(
              item =>
                String(
                  item.id
                ) ===
                String(
                  edit.dataset
                    .pncmsEdit
                )
            );


          if (row) {

            openCollegeEditor(
              row
            );

          }

          return;

        }


        const deleteCollege =
          event.target.closest(
            '[data-pncms-delete]'
          );


        if (deleteCollege) {

          event.preventDefault();


          deleteCollegeFromCMS(
            deleteCollege
          );


          return;

        }


        const filter =
          event.target.closest(
            '[data-pncms-filter]'
          );

        if (filter) {

          event.preventDefault();

          collegeCMSFilter =
            filter.dataset
              .pncmsFilter ||
            'all';

          collegeCMSApplyFilter();

          return;

        }


        const tab =
          event.target.closest(
            '[data-pncms-tab]'
          );

        if (tab) {

          event.preventDefault();

          collegeCMSSwitchTab(
            tab.dataset
              .pncmsTab
          );

          return;

        }


        const close =
          event.target.closest(
            '[data-pncms-close]'
          );

        if (close) {

          event.preventDefault();

          collegeCMSSelectedId =
            null;


          const editor =
            document.querySelector(
              '[data-pncms-editor]'
            );


          if (editor) {

            editor.innerHTML =
              collegeCMSEmptyEditor();

          }

          return;

        }


        const generate =
          event.target.closest(
            '[data-pncms-generate-slug]'
          );

        if (generate) {

          event.preventDefault();


          const form =
            generate.closest(
              '[data-pncms-form]'
            );

          const name =
            form?.querySelector(
              '[data-pncms-name]'
            );

          const slug =
            form?.querySelector(
              '[data-pncms-slug]'
            );


          if (
            name &&
            slug
          ) {

            slug.value =
              collegeCMSSlug(
                name.value
              );

          }

          return;

        }



        const removeMedia =
          event.target.closest(
            '[data-pncms-remove-media]'
          );

        if (removeMedia) {

          event.preventDefault();


          const form =
            removeMedia.closest(
              '[data-pncms-form]'
            );

          if (!form) {
            return;
          }


          const kind =
            removeMedia.dataset
              .pncmsRemoveMedia ===
            'logo'
              ? 'logo'
              : 'cover';


          const target =
            kind ===
            'logo'
              ? form.querySelector(
                  '[data-pncms-logo-url]'
                )
              : form.querySelector(
                  '[data-pncms-image-url]'
                );


          const preview =
            kind ===
            'logo'
              ? form.querySelector(
                  '[data-pncms-logo-preview]'
                )
              : form.querySelector(
                  '[data-pncms-cover-preview]'
                );


          if (target) {

            target.value =
              '';

          }


          if (preview) {

            preview.classList.remove(
              'has-image'
            );


            preview.innerHTML =
              `
                <span class="pncms-upload-drop__icon">
                  +
                </span>

                <strong>
                  ${
                    kind ===
                    'logo'
                      ? 'Upload college logo'
                      : 'Upload campus image'
                  }
                </strong>

                <small>
                  Click to choose from your computer
                </small>
              `;

          }


          if (
            kind ===
            'cover'
          ) {

            form
              .querySelector(
                '.pncms-editor__cover-image'
              )
              ?.remove();

          }


          if (
            kind ===
            'logo'
          ) {

            const logoBox =
              form.querySelector(
                '.pncms-editor__logo'
              );

            const name =
              form.querySelector(
                '[data-pncms-name]'
              )?.value ||
              'PN';


            if (logoBox) {

              logoBox.textContent =
                collegeCMSInitials(
                  name
                );

            }

          }


          collegeCMSToast(
            'Image removed from this college. Save changes to confirm.'
          );

          return;

        }



        const save =
          event.target.closest(
            '[data-pncms-save]'
          );

        if (save) {

          event.preventDefault();

          submitCollegeEditor(
            save.dataset
              .pncmsSave ||
            'save'
          );

        }

      }
    );



    /*
      College media upload.
      Uses the existing authenticated Supabase Storage
      transport exposed through PeerNestDB.
    */

    document.addEventListener(
      'change',
      async event => {

        const input =
          event.target.closest?.(
            '[data-pncms-media-file]'
          );

        if (!input) {
          return;
        }


        const file =
          input.files?.[0];

        if (!file) {
          return;
        }


        const form =
          input.closest(
            '[data-pncms-form]'
          );

        if (!form) {
          return;
        }


        const kind =
          input.dataset
            .pncmsMediaFile ===
          'logo'
            ? 'logo'
            : 'cover';


        const status =
          form.querySelector(
            '[data-pncms-upload-status]'
          );


        const name =
          form.querySelector(
            '[data-pncms-name]'
          )?.value ||
          'college';


        const slug =
          form.querySelector(
            '[data-pncms-slug]'
          )?.value ||
          collegeCMSSlug(
            name
          ) ||
          'draft';


        const collegeKey =
          form.dataset
            .pncmsId ||
          slug;


        const target =
          kind ===
          'logo'
            ? form.querySelector(
                '[data-pncms-logo-url]'
              )
            : form.querySelector(
                '[data-pncms-image-url]'
              );


        const preview =
          kind ===
          'logo'
            ? form.querySelector(
                '[data-pncms-logo-preview]'
              )
            : form.querySelector(
                '[data-pncms-cover-preview]'
              );


        const localPreview =
          URL.createObjectURL(
            file
          );


        if (preview) {

          preview.classList.add(
            'has-image',
            'is-uploading'
          );

          preview.innerHTML =
            `
              <img
                src="${escapeHTML(localPreview)}"
                alt=""
              >

              <div class="pncms-upload-drop__overlay">
                <span class="pncms-upload-spinner"></span>
                <strong>Uploading…</strong>
              </div>
            `;

        }


        if (status) {

          status.hidden =
            false;

          status.classList.remove(
            'is-error'
          );

          status.textContent =
            kind ===
            'logo'
              ? 'Uploading college logo…'
              : 'Uploading campus image…';

        }


        input.disabled =
          true;


        try {

          if (
            typeof window
              .PeerNestDB
              ?.uploadCollegeMedia !==
            'function'
          ) {

            throw new Error(
              'College media uploader is not available.'
            );

          }


          const publicURL =
            await window.PeerNestDB
              .uploadCollegeMedia(
                file,
                collegeKey,
                kind
              );


          if (target) {

            target.value =
              publicURL;

          }


          if (preview) {

            preview.classList.remove(
              'is-uploading'
            );

            preview.classList.add(
              'has-image'
            );


            preview.innerHTML =
              `
                <img
                  src="${escapeHTML(publicURL)}"
                  alt=""
                >

                <div class="pncms-upload-drop__overlay">

                  <span class="pncms-upload-drop__icon">
                    ↥
                  </span>

                  <strong>
                    ${
                      kind ===
                      'logo'
                        ? 'Replace logo'
                        : 'Replace cover'
                    }
                  </strong>

                  <small>
                    Click to choose another image
                  </small>

                </div>
              `;

          }


          /*
            Update the large editor header immediately
            when a cover is changed.
          */

          if (
            kind ===
            'cover'
          ) {

            const cover =
              form.querySelector(
                '.pncms-editor__cover'
              );

            if (cover) {

              let heroImage =
                cover.querySelector(
                  '.pncms-editor__cover-image'
                );


              if (!heroImage) {

                heroImage =
                  document.createElement(
                    'img'
                  );

                heroImage.className =
                  'pncms-editor__cover-image';

                cover.prepend(
                  heroImage
                );

              }


              heroImage.src =
                publicURL;

          }

          }


          if (
            kind ===
            'logo'
          ) {

            const logoBox =
              form.querySelector(
                '.pncms-editor__logo'
              );

            if (logoBox) {

              logoBox.innerHTML =
                `
                  <img
                    src="${escapeHTML(publicURL)}"
                    alt=""
                  >
                `;

            }

          }


          if (status) {

            status.textContent =
              kind ===
              'logo'
                ? '✓ Logo uploaded. Save the college to keep this change.'
                : '✓ Campus image uploaded. Save the college to keep this change.';

          }


          collegeCMSToast(
            kind ===
            'logo'
              ? 'College logo uploaded.'
              : 'Campus image uploaded.'
          );

        }


        catch (error) {

          console.error(
            '[PeerNest Admin] college media:',
            error
          );


          if (status) {

            status.hidden =
              false;

            status.classList.add(
              'is-error'
            );

            status.textContent =
              error?.message ||
              'Image upload failed.';

          }


          collegeCMSToast(
            error?.message ||
            'Image upload failed.',
            'error'
          );


          /*
            Restore previous image from the hidden URL.
          */

          const previousURL =
            target?.value ||
            '';


          if (preview) {

            preview.classList.remove(
              'is-uploading'
            );


            if (previousURL) {

              preview.classList.add(
                'has-image'
              );

              preview.innerHTML =
                `
                  <img
                    src="${escapeHTML(previousURL)}"
                    alt=""
                  >

                  <div class="pncms-upload-drop__overlay">
                    <span class="pncms-upload-drop__icon">↥</span>
                    <strong>Try another image</strong>
                  </div>
                `;

            }

            else {

              preview.classList.remove(
                'has-image'
              );

              preview.innerHTML =
                `
                  <span class="pncms-upload-drop__icon">+</span>
                  <strong>
                    ${
                      kind ===
                      'logo'
                        ? 'Upload college logo'
                        : 'Upload campus image'
                    }
                  </strong>
                  <small>
                    Click to choose from your computer
                  </small>
                `;

            }

          }

        }


        finally {

          input.disabled =
            false;

          input.value =
            '';

          URL.revokeObjectURL(
            localPreview
          );

        }

      }
    );



    document.addEventListener(
      'input',
      event => {

        const form =
          event.target.closest?.(
            '[data-pncms-form]'
          );

        if (!form) {
          return;
        }


        if (
          event.target.matches(
            '[data-pncms-name], [data-pncms-city], [data-pncms-state]'
          )
        ) {

          const previewName =
            form.querySelector(
              '[data-pncms-preview-name]'
            );

          const previewLocation =
            form.querySelector(
              '[data-pncms-preview-location]'
            );

          const name =
            form.querySelector(
              '[data-pncms-name]'
            )?.value.trim();

          const city =
            form.querySelector(
              '[data-pncms-city]'
            )?.value.trim();

          const state =
            form.querySelector(
              '[data-pncms-state]'
            )?.value.trim();


          if (previewName) {

            previewName.textContent =
              name ||
              'New college';

          }


          if (previewLocation) {

            previewLocation.textContent =
              [
                city,
                state
              ]
                .filter(Boolean)
                .join(', ') ||
              'PeerNest college profile';

          }

        }


        if (
          event.target.matches(
            '[data-pncms-image-url], [data-pncms-logo-url]'
          )
        ) {

          const cover =
            form.querySelector(
              '[data-pncms-image-url]'
            )?.value.trim();

          const logo =
            form.querySelector(
              '[data-pncms-logo-url]'
            )?.value.trim();

          const coverPreview =
            form.querySelector(
              '[data-pncms-cover-preview]'
            );

          const logoPreview =
            form.querySelector(
              '[data-pncms-logo-preview]'
            );


          if (coverPreview) {

            coverPreview.innerHTML =
              collegeCMSMedia(
                cover,
                'Cover preview'
              );

          }


          if (logoPreview) {

            logoPreview.innerHTML =
              collegeCMSMedia(
                logo,
                'Logo preview',
                true
              );

          }

        }

      }
    );

  }


  function renderColleges(
    source
  ) {

    ensureCollegeCMSBindings();
    ensureCollegeRequestBindings();


    const allRows = Array.isArray(source) ? source : [];
    // Counters must not shrink when the admin searches the list.
    const statsRows = Array.isArray(rows) ? rows : [];


    const publishedCount =
      statsRows.filter(
        row =>
          Boolean(
            row.is_published
          )
      ).length;


    const draftCount =
      statsRows.length -
      publishedCount;


    const featuredCount =
      statsRows.filter(
        row =>
          Boolean(
            row.is_featured
          )
      ).length;


    const cards =
      allRows
        .map(
          row => {

            const published =
              Boolean(
                row.is_published
              );

            const featured =
              Boolean(
                row.is_featured
              );

            const image =
              row.logo_url ||
              row.image_url ||
              '';

            const hidden =
              collegeCMSFilter ===
              'published'
                ? !published
                : collegeCMSFilter ===
                  'draft'
                    ? published
                    : collegeCMSFilter ===
                      'featured'
                        ? !featured
                        : false;


            return `
              <article
                class="pncms__card"
                data-pncms-card
                data-pncms-published="${
                  published
                    ? 'true'
                    : 'false'
                }"
                data-pncms-featured="${
                  featured
                    ? 'true'
                    : 'false'
                }"
                ${
                  hidden
                    ? 'hidden'
                    : ''
                }
              >

                <div class="pncms__thumb">

                  ${
                    image
                      ? `
                          <img
                            src="${escapeHTML(image)}"
                            alt=""
                          >
                        `
                      : `
                          <span class="pncms__initials">
                            ${escapeHTML(
                              collegeCMSInitials(
                                row.name
                              )
                            )}
                          </span>
                        `
                  }

                </div>


                <div class="pncms__card-main">

                  <div class="pncms__card-top">

                    <h3 class="pncms__card-name">
                      ${escapeHTML(
                        row.name ||
                        'Unnamed college'
                      )}
                    </h3>

                    <span class="pncms__status ${
                      published
                        ? 'pncms__status--published'
                        : 'pncms__status--draft'
                    }">
                      ${
                        published
                          ? 'Live'
                          : 'Draft'
                      }
                    </span>

                  </div>


                  <div class="pncms__meta">

                    <span>
                      ${escapeHTML(
                        collegeCMSLocation(
                          row
                        )
                      )}
                    </span>

                    ${
                      row.college_type
                        ? `
                            <span>
                              ${escapeHTML(
                                row.college_type
                              )}
                            </span>
                          `
                        : ''
                    }

                  </div>


                  <div class="pncms__slug">
                    /colleges/${escapeHTML(
                      row.slug ||
                      'no-slug'
                    )}
                  </div>


                  <div class="pncms__card-actions">

                    <button
                      type="button"
                      class="pncms__mini pncms__mini--edit"
                      data-pncms-edit="${escapeHTML(
                        row.id
                      )}"
                    >
                      Edit
                    </button>


                    <button
                      type="button"
                      class="pncms__mini"
                      data-pnops-college-publish="${escapeHTML(
                        row.id
                      )}"
                      data-pnops-next="${
                        published
                          ? 'false'
                          : 'true'
                      }"
                    >
                      ${
                        published
                          ? 'Unpublish'
                          : 'Publish'
                      }
                    </button>


                    <button
                      type="button"
                      class="pncms__mini"
                      data-pncms-delete="${escapeHTML(
                        row.id
                      )}"
                    >
                      Delete
                    </button>

                  </div>

                </div>

              </article>
            `;

          }
        )
        .join('');


    if (
      collegeCMSSelectedId
    ) {

      window.setTimeout(
        () => {

          const selected =
            rows.find(
              item =>
                String(
                  item.id
                ) ===
                String(
                  collegeCMSSelectedId
                )
            );

          if (selected) {

            openCollegeEditor(
              selected
            );

          }

        },
        0
      );

    }


    return `
      <section class="pncms">

        <div class="pncms__hero">

          <div>

            <span class="pncms__eyebrow">
              PeerNest College Studio
            </span>

            <h2>
              Colleges, beautifully managed.
            </h2>

            <p>
              Create, refine and publish the college profiles
              students use across discovery, Compare and PeerNest.
            </p>

          </div>


          <div class="pncms__hero-actions">
            <button type="button" class="pncms__all-button" data-pncms-view-all>
              View All Colleges ↗
            </button>
            <button
              type="button"
              class="pncms__add"
              data-pncms-add
            >
              <span class="pncms__add-mark">+</span>
              Add College
            </button>
          </div>

        </div>


        <div class="pncms__stats">

          <div class="pncms__stat">
            <span>Managed colleges</span>
            <strong>${statsRows.length}</strong>
          </div>

          <div class="pncms__stat">
            <span>Published</span>
            <strong>${publishedCount}</strong>
          </div>

          <div class="pncms__stat">
            <span>Drafts</span>
            <strong>${draftCount}</strong>
          </div>

          <div class="pncms__stat">
            <span>Featured</span>
            <strong>${featuredCount}</strong>
          </div>

        </div>


        <div data-pncms-requests-root>${collegeRequestPanelHTML()}</div>

        <div class="pncms__workspace">

          <section class="pncms__library">

            <header class="pncms__library-head">

              <div class="pncms__library-title">

                <strong>College library</strong>

                <span>
                  ${allRows.length}${allRows.length === statsRows.length ? '' : ` of ${statsRows.length}`} records
                </span>

              </div>


              <div class="pncms__filters">

                <button
                  type="button"
                  class="pncms__filter ${
                    collegeCMSFilter ===
                    'all'
                      ? 'is-active'
                      : ''
                  }"
                  data-pncms-filter="all"
                >
                  All
                </button>

                <button
                  type="button"
                  class="pncms__filter ${
                    collegeCMSFilter ===
                    'published'
                      ? 'is-active'
                      : ''
                  }"
                  data-pncms-filter="published"
                >
                  Published
                </button>

                <button
                  type="button"
                  class="pncms__filter ${
                    collegeCMSFilter ===
                    'draft'
                      ? 'is-active'
                      : ''
                  }"
                  data-pncms-filter="draft"
                >
                  Drafts
                </button>

                <button
                  type="button"
                  class="pncms__filter ${
                    collegeCMSFilter ===
                    'featured'
                      ? 'is-active'
                      : ''
                  }"
                  data-pncms-filter="featured"
                >
                  Featured
                </button>

              </div>

            </header>


            <div class="pncms__cards">

              ${
                cards ||
                `
                  <div class="pncms__empty-list">
                    No colleges found.
                  </div>
                `
              }

            </div>

          </section>


          <section
            class="pncms__editor"
            data-pncms-editor
          >
            ${collegeCMSEmptyEditor()}
          </section>

        </div>

      </section>
    `;

  }


  /* PN6_COMPARE_LIVE_DASHBOARD */

  /* PN_ADMIN_SESSION_VERIFICATION_V1 */

  function bookingVerificationHTML(
    row
  ) {

    if (
      row._pn_type ===
      'event'
    ) {

      return '';

    }


    if (
      row.booking_type ===
      'compare_live'
    ) {

      return `
        <div class="pnops-session-check">
          <small>
            Compare Live session
          </small>
        </div>
      `;

    }


    const now =
      Date.now();

    const end =
      row.ends_at
        ? new Date(
            row.ends_at
          ).getTime()
        : 0;

    const eligible =
      row.completion_eligible_at
        ? new Date(
            row.completion_eligible_at
          ).getTime()
        : 0;

    const mentor =
      Boolean(
        row.mentor_joined_at
      );

    const student =
      Boolean(
        row.student_joined_at
      );


    let label =
      'Awaiting session';

    let review =
      false;


    if (
      row.status ===
      'completed'
    ) {

      label =
        'Completed';

    }
    else if (
      end &&
      now > end &&
      mentor &&
      !student
    ) {

      label =
        'Student no-show';

      review =
        true;

    }
    else if (
      end &&
      now > end &&
      !mentor &&
      student
    ) {

      label =
        'Mentor no-show';

      review =
        true;

    }
    else if (
      end &&
      now > end &&
      !mentor &&
      !student
    ) {

      label =
        'No join activity';

      review =
        true;

    }
    else if (
      end &&
      now > end &&
      mentor &&
      student
    ) {

      label =
        'Completion overdue';

      review =
        true;

    }
    else if (
      mentor &&
      student &&
      eligible &&
      now >= eligible
    ) {

      label =
        'Completion eligible';

    }
    else if (
      mentor &&
      student
    ) {

      label =
        'In progress';

    }
    else if (
      mentor
    ) {

      label =
        'Waiting for student';

    }
    else if (
      student
    ) {

      label =
        'Waiting for mentor';

    }


    return `
      <div
        class="pnops-session-check"
        data-review="${review ? 'true' : 'false'}"
      >

        <strong>
          ${escapeHTML(label)}
        </strong>

        <small>
          ${mentor ? '✓' : '○'} Mentor
          ·
          ${student ? '✓' : '○'} Student
          ·
          ${
            eligible &&
            now >= eligible
              ? '✓'
              : '○'
          }
          50%
        </small>

        ${
          review
            ? `
              <span>
                REVIEW REQUIRED
              </span>
            `
            : ''
        }

      </div>
    `;

  }


  function renderBookings(
    source
  ) {

    const filtered =
      source.filter(
        row => {

          const type =
            row._pn_type ||
            'mentor';


          const status =
            clean(
              first(
                row,
                [
                  'status',
                  'booking_status'
                ],
                'unknown'
              )
            )
              .toLowerCase();


          return (
            (
              bookingType ===
                'all' ||
              bookingType ===
                type
            ) &&
            (
              bookingStatus ===
                'all' ||
              bookingStatus ===
                status
            )
          );

        }
      );


    return table(
      [
        'Type',
        'Booking',
        'Student',
        'Mentor / Event',
        'College',
        'Status',
        'Date'
      ],

      filtered
        .map(
          row => {

            const type =
              row._pn_type ||
              'mentor';


            const studentName =
              first(
                row,
                [
                  'student_name',
                  'full_name',
                  'student_id',
                  'user_id',
                  'profile_id'
                ],
                '—'
              );


            const studentEmail =
              first(
                row,
                [
                  'student_email'
                ],
                ''
              );


            const linked =
              type ===
              'event'
                ? first(
                    row,
                    [
                      'event_title',
                      'event_id'
                    ],
                    '—'
                  )
                : first(
                    row,
                    [
                      'mentor_name',
                      'mentor_id',
                      'mentor_profile_id'
                    ],
                    '—'
                  );


            const linkedSecondary =
              type ===
              'mentor'
                ? first(
                    row,
                    [
                      'mentor_email'
                    ],
                    ''
                  )
                : '';


            const college =
              first(
                row,
                [
                  'college_name'
                ],
                '—'
              );


            return `
              <tr>

                <td>
                  ${pill(
                    type ===
                      'mentor' &&
                    row.booking_type ===
                      'compare_live'
                      ? 'compare_live'
                      : type
                  )}
                </td>


                <td>
                  ${escapeHTML(
                    first(
                      row,
                      ['id']
                    )
                  )}
                </td>


                <td>

                  <span class="pnops__primary">
                    ${escapeHTML(studentName)}
                  </span>

                  ${
                    studentEmail
                      ? `
                        <span class="pnops__secondary">
                          ${escapeHTML(studentEmail)}
                        </span>
                      `
                      : ''
                  }

                </td>


                <td>

                  <span class="pnops__primary">
                    ${escapeHTML(linked)}
                  </span>

                  ${
                    linkedSecondary
                      ? `
                        <span class="pnops__secondary">
                          ${escapeHTML(linkedSecondary)}
                        </span>
                      `
                      : ''
                  }

                </td>


                <td>
                  ${escapeHTML(college)}
                </td>


                <td>

                  ${pill(
                    first(
                      row,
                      [
                        'status',
                        'booking_status'
                      ],
                      'unknown'
                    )
                  )}

                  ${bookingVerificationHTML(
                    row
                  )}

                </td>


                <td>
                  ${escapeHTML(
                    dateText(
                      first(
                        row,
                        [
                          'scheduled_at',
                          'starts_at',
                          'start_time',
                          'event_date',
                          'created_at'
                        ],
                        ''
                      )
                    )
                  )}
                </td>

              </tr>
            `;

          }
        )
        .join('')
    );

  }


  function renderPayments() {

    /*
      Payments are owned entirely by
      pn-phase5-finance-v2.js.

      Admin Operations must render NOTHING here.
    */

    return '';

  }


  function renderEvents(
    source
  ) {

    return table(
      [
        'Event',
        'Status',
        'Date',
        'Capacity'
      ],

      source
        .map(
          row => `
            <tr>

              <td>

                <span class="pnops__primary">
                  ${escapeHTML(
                    first(
                      row,
                      [
                        'title',
                        'name'
                      ],
                      'Untitled event'
                    )
                  )}
                </span>

              </td>

              <td>
                ${pill(
                  first(
                    row,
                    ['status'],
                    row.is_published
                      ? 'published'
                      : 'draft'
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  dateText(
                    first(
                      row,
                      [
                        'starts_at',
                        'start_at',
                        'event_date',
                        'created_at'
                      ],
                      ''
                    )
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'capacity',
                      'seats_available'
                    ]
                  )
                )}
              </td>

            </tr>
          `
        )
        .join('')
    );

  }


  function renderCommunities(
    source
  ) {

    return table(
      [
        'Community',
        'Category',
        'Status',
        'Created'
      ],

      source
        .map(
          row => `
            <tr>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'name',
                      'title'
                    ],
                    'Untitled community'
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'category',
                      'community_type'
                    ]
                  )
                )}
              </td>

              <td>
                ${pill(
                  first(
                    row,
                    ['status'],
                    row.is_published
                      ? 'published'
                      : 'draft'
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  dateText(
                    row.created_at
                  )
                )}
              </td>

            </tr>
          `
        )
        .join('')
    );

  }


  function renderReviews(
    source
  ) {

    return table(
      [
        'Rating',
        'Review',
        'Status',
        'Created'
      ],

      source
        .map(
          row => `
            <tr>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    ['rating']
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'review_text',
                      'comment',
                      'body'
                    ]
                  )
                )}
              </td>

              <td>
                ${pill(
                  first(
                    row,
                    ['status'],
                    'published'
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  dateText(
                    row.created_at
                  )
                )}
              </td>

            </tr>
          `
        )
        .join('')
    );

  }


  function renderAnalytics(
    source
  ) {

    return table(
      [
        'Event',
        'User',
        'Source',
        'Created'
      ],

      source
        .map(
          row => `
            <tr>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'event_name',
                      'event',
                      'name',
                      'action'
                    ],
                    'Analytics event'
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'user_id',
                      'profile_id',
                      'actor_id'
                    ]
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'page',
                      'path',
                      'source',
                      'category'
                    ]
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  dateText(
                    row.created_at
                  )
                )}
              </td>

            </tr>
          `
        )
        .join('')
    );

  }


  function renderLogs(
    source
  ) {

    return table(
      [
        'Action',
        'Admin',
        'Resource',
        'Created'
      ],

      source
        .map(
          row => `
            <tr>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'action',
                      'event',
                      'activity'
                    ],
                    'Admin action'
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'admin_id',
                      'actor_id',
                      'user_id'
                    ]
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  first(
                    row,
                    [
                      'entity_type',
                      'resource_type',
                      'target_type'
                    ]
                  )
                )}
              </td>

              <td>
                ${escapeHTML(
                  dateText(
                    row.created_at
                  )
                )}
              </td>

            </tr>
          `
        )
        .join('')
    );

  }


  function render() {

    const body =
      root.querySelector(
        '[data-pnops-body]'
      );


    const meta =
      root.querySelector(
        '[data-pnops-meta]'
      );


    if (!body) {
      return;
    }


    filtersHTML();


    const source =
      searchRows(
        rows
      );


    const renderers = {

      users:
        renderUsers,

      colleges:
        renderColleges,

      bookings:
        renderBookings,

      payments:
        renderPayments,

      events:
        renderEvents,

      communities:
        renderCommunities,

      reviews:
        renderReviews,

      analytics:
        renderAnalytics,

      logs:
        renderLogs

    };


    body.innerHTML =
      renderers[currentTab]
        ? renderers[currentTab](
            source
          )
        : `
            <div class="pnops__state">
              No renderer available.
            </div>
          `;


    if (meta) {

      meta.textContent =
        `${source.length} record${
          source.length === 1
            ? ''
            : 's'
        } loaded`;

    }


    /* PN5A_SHARED_RESCHEDULE_ADMIN_HOOK */

    if (
      currentTab ===
      'bookings'
    ) {

      window.PeerNestReschedule
        ?.attachAdminButtons(
          root,
          source.filter(
            row =>
              row?._pn_type ===
                'mentor' &&
              row?.booking_type ===
                'single'
          )
        );

    }


    /* PN8A_ADMIN_EXTENSION_HOOK */

    window.PeerNestAdmin8A
      ?.enhance(
        currentTab,
        source
      );


    bindRowActions();

  }


  async function bindMentorPricing() {

    if (
      currentTab !==
      'payments'
    ) {
      return;
    }


    const section =
      root.querySelector(
        '[data-pnops-mentor-pricing]'
      );


    if (!section) {
      return;
    }


    const price15 =
      section.querySelector(
        '[data-pnops-price-15]'
      );


    const price30 =
      section.querySelector(
        '[data-pnops-price-30]'
      );


    const currency =
      section.querySelector(
        '[data-pnops-pricing-currency]'
      );


    const saveButton =
      section.querySelector(
        '[data-pnops-save-mentor-pricing]'
      );


    const message =
      section.querySelector(
        '[data-pnops-pricing-message]'
      );


    if (
      !price15 ||
      !price30 ||
      !currency ||
      !saveButton
    ) {
      return;
    }


    const setMessage =
      (
        value,
        isError = false
      ) => {

        if (!message) {
          return;
        }


        message.textContent =
          value;


        message.style.color =
          isError
            ? '#b42318'
            : '';

      };


    const updateCurrencyLabels =
      () => {

        section
          .querySelectorAll(
            '[data-pnops-price-currency]'
          )
          .forEach(
            label => {

              label.textContent =
                currency.value ||
                'INR';

            }
          );

      };


    currency.addEventListener(
      'change',
      updateCurrencyLabels
    );


    try {

      const pricing =
        await window.PeerNestDB
          .request(
            'mentor_session_pricing',
            'id=eq.1&select=id,price_15,price_30,currency,updated_at'
          );


      const row =
        Array.isArray(pricing)
          ? pricing[0]
          : null;


      if (!row) {

        throw new Error(
          'Global mentor pricing record was not found.'
        );

      }


      price15.value =
        row.price_15 ??
        '';


      price30.value =
        row.price_30 ??
        '';


      currency.value =
        String(
          row.currency ||
          'INR'
        ).toUpperCase();


      updateCurrencyLabels();


      setMessage(
        row.price_15 &&
        row.price_30

          ? 'Pricing is active.'

          : 'Set both prices to enable paid mentor bookings.'
      );

    }
    catch (error) {

      console.error(
        '[PeerNest Admin] mentor pricing load:',
        error
      );


      setMessage(
        error?.message ||
        'Could not load mentor pricing.',
        true
      );

    }


    saveButton.addEventListener(
      'click',
      async () => {

        const value15 =
          Number(
            price15.value
          );


        const value30 =
          Number(
            price30.value
          );


        if (
          !Number.isFinite(value15) ||
          value15 <= 0
        ) {

          setMessage(
            'Enter a valid 15-minute price.',
            true
          );

          price15.focus();

          return;

        }


        if (
          !Number.isFinite(value30) ||
          value30 <= 0
        ) {

          setMessage(
            'Enter a valid 30-minute price.',
            true
          );

          price30.focus();

          return;

        }


        saveButton.disabled =
          true;


        saveButton.textContent =
          'Saving…';


        setMessage(
          'Updating global pricing…'
        );


        try {

          const result =
            await window.PeerNestDB
              .request(
                'mentor_session_pricing',

                'id=eq.1',

                {
                  method:
                    'PATCH',

                  headers:{
                    Prefer:
                      'return=representation'
                  },

                  body:{
                    price_15:
                      value15,

                    price_30:
                      value30,

                    currency:
                      currency.value,

                    updated_at:
                      new Date()
                        .toISOString()
                  }
                }
              );


          const saved =
            Array.isArray(result)
              ? result[0]
              : null;


          if (!saved) {

            throw new Error(
              'Pricing was not returned after save.'
            );

          }


          price15.value =
            saved.price_15;


          price30.value =
            saved.price_30;


          currency.value =
            String(
              saved.currency ||
              currency.value ||
              'INR'
            ).toUpperCase();


          updateCurrencyLabels();


          setMessage(
            'Pricing saved. All mentor bookings now use these rates.'
          );

        }
        catch (error) {

          console.error(
            '[PeerNest Admin] mentor pricing save:',
            error
          );


          setMessage(
            error?.message ||
            'Could not save mentor pricing.',
            true
          );

        }
        finally {

          saveButton.disabled =
            false;


          saveButton.textContent =
            'Save Pricing';

        }

      }
    );

  }




  function bindRowActions() {

    bindMentorPricing();

    root
      .querySelectorAll(
        '[data-pnops-user-status]'
      )
      .forEach(select => {

        select.addEventListener(
          'change',
          async () => {

            select.disabled =
              true;


            try {

              await window.PeerNestDB
                .request(
                  'rpc/admin_update_user_status',
                  '',
                  {
                    method:
                      'POST',

                    body:{
                      target_user_id:
                        select.dataset
                          .pnopsUserStatus,

                      new_status:
                        select.value
                    }
                  }
                );


              await load(
                'users'
              );

            }
            catch (error) {

              console.error(
                '[PeerNest Admin] user status:',
                error
              );


              alert(
                error?.message ||
                'Could not update this account.'
              );


              select.disabled =
                false;

            }

          }
        );

      });


    root
      .querySelectorAll(
        '[data-pnops-college-publish]'
      )
      .forEach(button => {

        button.addEventListener(
          'click',
          async () => {

            button.disabled =
              true;


            try {

              await window.PeerNestDB
                .request(
                  'colleges',

                  `id=eq.${encodeURIComponent(
                    button.dataset
                      .pnopsCollegePublish
                  )}`,

                  {
                    method:
                      'PATCH',

                    headers:{
                      Prefer:
                        'return=representation'
                    },

                    body:{
                      is_published:
                        button.dataset
                          .pnopsNext ===
                        'true'
                    }
                  }
                );


              await load(
                'colleges'
              );

            }
            catch (error) {

              console.error(
                '[PeerNest Admin] college publish:',
                error
              );


              alert(
                error?.message ||
                'Could not update this college.'
              );


              button.disabled =
                false;

            }

          }
        );

      });

  }


  let pnopsLoadRevision = 0;


  async function load(
    tab
  ) {

    const loadRevision =
      ++pnopsLoadRevision;



    currentTab =
      tab;


    const title =
      root.querySelector(
        '[data-pnops-title]'
      );


    const description =
      root.querySelector(
        '[data-pnops-description]'
      );


    const body =
      root.querySelector(
        '[data-pnops-body]'
      );


    if (title) {

      title.textContent =
        LABELS[tab] ||
        tab;

    }


    if (description) {

      description.textContent =
        DESCRIPTIONS[tab] ||
        '';

    }


    if (body) {

      body.innerHTML = `
        <div class="pnops__state">
          Loading live data…
        </div>
      `;

    }


    try {

      const pnopsNextRows =
        await fetchRows(
          tab
        );


      /* PNOPS_STALE_LOAD_GUARD */

      if (
        loadRevision !==
          pnopsLoadRevision
        ||
        currentTab !==
          tab
      ) {
        return;
      }


      rows =
        pnopsNextRows;


      render();

      if (tab === 'colleges') {
        // Requests load independently; published colleges and approved-request colleges share this library.
        void refreshCollegeRequests();
      }

    }
    catch (error) {

      if (
        loadRevision !==
          pnopsLoadRevision
        ||
        currentTab !==
          tab
      ) {
        return;
      }


      console.error(
        '[PeerNest Admin Operations]',
        tab,
        error
      );


      rows =
        [];


      if (body) {

        body.innerHTML = `
          <div
            class="pnops__state pnops__state--error"
          >
            ${
              escapeHTML(
                error?.message ||
                'This module is not available yet.'
              )
            }
          </div>
        `;

      }

    }

  }


  async function init() {

    if (ready) {
      return;
    }


    if (
      !window.PeerNestDB
    ) {

      setTimeout(
        init,
        100
      );

      return;

    }


    try {

      const profile =
        await window.PeerNestDB
          .getMyProfile();


      if (
        !profile ||
        profile.role !==
          'admin' ||
        profile.account_status !==
          'active'
      ) {
        return;
      }


      currentProfile =
        profile;


      ready =
        true;


      mount();


      const requested =
        dashboard.dataset
          .pnadmActiveOperation;


      await load(
        LABELS[requested]
          ? requested
          : 'users'
      );

    }
    catch (error) {

      console.error(
        '[PeerNest Admin Operations] init:',
        error
      );

    }

  }


  document.addEventListener(
    'peernest:admin-operation-view',
    event => {

      const key =
        event?.detail?.key;


      if (
        LABELS[key]
      ) {

        dashboard.dataset
          .pnadmActiveOperation =
          key;


        if (ready) {

          load(
            key
          );

        }

      }

    }
  );


  document.addEventListener(
    'peernest:dashboard-ready',
    event => {

      if (
        event?.detail?.profile?.role ===
        'admin'
      ) {

        init();

      }

    }
  );


  init();

})();
